@if (text) {
  <i class="fas fa-info-circle"></i>
  <app-tooltip position="tr">
    <p class="text-tooltip" [innerHTML]="text"></p>
  </app-tooltip>
}
